import { TradeBoxSkeleton } from '../../CreateTrade/AssetPageInitiateTradeBox/TradeBoxSkeleton';

export const TradeSkeleton = () => <TradeBoxSkeleton withNav />;
